// styling
import styles from './styles.module.scss';

// utils
import { useEffect, useState } from 'react';

// assets
import logoPNG from '@assets/tuligalive.jpg';

const DISMISS_KEY = 'appBannerDismissedAt';
const DISMISS_DAYS = 14;

const STORE_LINKS = {
    ios: 'https://apps.apple.com/co/app/tu-liga-live/id6797860990',
    android: 'https://play.google.com/store/apps/details?id=com.estupinan.tuligalive.app',
};

// iOS on modern Safari reports as "MacIntel" but exposes touch points, unlike a real Mac
const getMobileOS = () => {
    const ua = navigator.userAgent || navigator.vendor || '';

    if (/android/i.test(ua)) return 'android';

    const isIOS = /iPad|iPhone|iPod/.test(ua)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) return 'ios';

    return null;
};

const AppDownloadBanner = () => {
    const [os, setOs] = useState(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const detectedOs = getMobileOS();
        if (!detectedOs) return;

        const dismissedAt = Number(localStorage.getItem(DISMISS_KEY));
        const daysSinceDismiss = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
        if (dismissedAt && daysSinceDismiss < DISMISS_DAYS) return;

        setOs(detectedOs);
        setVisible(true);
    }, []);

    const dismiss = () => {
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
        setVisible(false);
    };

    if (!visible || !os) return null;

    return (
        <div className={styles.banner}>
            <div className={styles.info}>
                <img className={styles.icon} src={logoPNG} alt="Tu Liga Live" />
                <div className={styles.text}>
                    <strong>Tu Liga Live</strong>
                    <span className="text-12">Vívela mejor desde la app</span>
                </div>
            </div>
            <div className={styles.actions}>
                <a
                    className={styles.cta}
                    href={STORE_LINKS[os]}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={dismiss}
                >
                    Abrir
                </a>
                <button type="button" className={styles.close} onClick={dismiss} aria-label="Cerrar">
                    <i className="icon icon-xmark" />
                </button>
            </div>
        </div>
    );
};

export default AppDownloadBanner;
